import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from "@material-ui/core"
import {DateRange, PlayArrow} from "@material-ui/icons"
import {useCallback, useEffect, useState} from "react"
import {Title, useRedirect} from "react-admin"
import {useQuizAssessmentAvailabilityDataProvider} from "../../../../providers/data-provider/quiz-assessment-availability.data.provider"
import {SectionHeader} from "./section-header"
import {useStyles} from "./styles"
import {formatDateTime} from "./utils"

export function AvailableTests() {
  const classes = useStyles()
  const redirect = useRedirect()
  const [quizzes, setQuizzes] = useState([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const {listAvailableTests} = useQuizAssessmentAvailabilityDataProvider()

  useEffect(() => {
    listAvailableTests().then(res => setQuizzes(res.data))
  }, [listAvailableTests])

  const handleStartQuiz = useCallback((availabilityId) => {
    redirect(`/test-solve/${availabilityId}`)
  }, [redirect])

  const handleChangePage = (_, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const paginatedQuizzes = quizzes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

  return (
    <Box p={3}>
      <Title title="Dashboard do aluno" />
      <SectionHeader
        icon={<DateRange className={classes.sectionIcon} />}
        title="Avaliações disponíveis"
        subtitle="Inicie uma avaliação dentro do período disponível."
      />
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Avaliação</TableCell>
              <TableCell>Turma</TableCell>
              <TableCell>Início</TableCell>
              <TableCell>Fim</TableCell>
              <TableCell>Questões</TableCell>
              <TableCell>Tempo da avaliação</TableCell>
              <TableCell>Realizar avaliação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedQuizzes.map((quiz) => (
              <TableRow key={quiz.id}>
                <TableCell>{quiz.name}</TableCell>
                <TableCell>{quiz.classes?.map((c) => c.name).join(', ') || '-'}</TableCell>
                <TableCell>{formatDateTime(quiz.start)}</TableCell>
                <TableCell>{formatDateTime(quiz.end)}</TableCell>
                <TableCell>{quiz.questionAmount}</TableCell>
                <TableCell>{quiz.durationInMinutes} minutos</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.startButton}
                    startIcon={<PlayArrow />}
                    onClick={() => handleStartQuiz(quiz.id)}
                  >
                    INICIAR AVALIAÇÃO
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {quizzes.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Nenhuma avaliação disponível
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={quizzes.length}
          page={page}
          onChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Linhas por página"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          onPageChange={handleChangePage}
        />
      </Paper>
    </Box>
  )
}
